import { useContext } from 'react';
import { ScrollContext } from '../contexts';
import type { ScrollContextProps } from '../contexts';

export default (): ScrollContextProps => useContext(ScrollContext);
